import {FILTER_TYPE} from "@constants/dataEnums";
/**
 * 此檔案是用來管理 router 的 enum
 */

export const TRANSFERIN_ENTEREDTYPE = Object.freeze({
	UNENTERED: `unentered`,
	ENTERED  : `entered`
});

export const TRANSFEROUT_MOVETYPE = Object.freeze({
	UNMOVEOUT: `unmoveout`,
	MOVEOUT  : `moveout`
});


export const LANDING_NAVIGATION_TABS = Object.freeze({
    TIME_SCHEDULING : `time-scheduling`,
    OVERVIEW        : `overview`,
    SHIFT_SCHEDULING: `shift-scheduling`,
    ARRIVE          : `arrive`
});

export const MEMBERS_TABS = Object.freeze({
    MEMBER_OVERVIEW : `member-overview`,
    RENT_CABINET    : `rent-cabinet`,
    GIFT            : `gift`,
    SMARTFITNESSBAND: `smartfitnessband`,
});

// 快速名單 與 一般名單
export const MEMBERS_OVERVIEW_TABS = Object.freeze({
    NORMAL: `normal`,
    QUICK : `quick`,
});

export const MEMBERS_MEMBER_DETAIL_TABS = Object.freeze({
	WORKOUT       : `workout`,
	BASIC         : `basic`,
	MEMBERSHIP    : `membership`,
	INBODY        : `inbody`,
	CONTACT_RECORD: `contact-record`,
	HC            : `cycle-purchase`,
	RENT_CABINET  : `rent-cabinet`,
	OTHER         : `other`,
	SMARTFITNESSBAND   : `smartfitnessband`,
});

export const IN_BODY_INTERVIEW_TABS = Object.freeze({
	SUMMARY: `summary`,
	COMPARE: `compare`,
	MEASURE: `measure`,
	NOTES  : `notes`,
});

export const ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS = Object.freeze({
	ON_SITE_ORDER : 1, // 現場訂單
	BATCH_ORDER   : 2, // 批次訂單
	CAMPAIGN_ORDER: 3, // 抵用券訂單
});

export const NON_MEMBER_TEMPORARY_INFO_PAGE = Object.freeze({
	[FILTER_TYPE.CUSTOMEROVERVIEW] : "customer",
	[FILTER_TYPE.GUESTOVERVIEW]   : "prospect",
});
